import * as React from "react";
import { Spin, Space, Typography } from "antd";
import { ReactNode } from "react";

import { classname } from "@ctra/utils";
import styles from "./BigAssValue.module.less";

const { Text } = Typography;

export enum BigAssValueVariant {
  Primary = "primary",
  Secondary = "secondary"
}

export interface BigAssValueProps {
  /**
   * Size variant
   */
  variant?: BigAssValueVariant;
  /**
   * Label appearing on top
   */
  label?: string;
  /**
   * Value
   */
  value: string | number | ReactNode;
  /**
   * Small print
   */
  sub?: string;
  /**
   * Loading state
   */
  loading?: boolean;
}

/**
 * Value indicator with small print explanation
 * @constructor
 */
const BigAssValue: React.FC<BigAssValueProps> = ({
  variant = BigAssValueVariant.Primary,
  value,
  label,
  sub,
  loading = false
}) => {
  return (
    <Spin spinning={loading}>
      <Space size="small" direction="vertical" className={styles.Container}>
        {label && (
          <Text
            type="secondary"
            className={classname(
              styles.Label,
              variant === BigAssValueVariant.Secondary ? styles.Secondary : ""
            )}
          >
            {label}
          </Text>
        )}
        <Text className={styles.Value}>{value}</Text>
        {sub && (
          <Text
            type="secondary"
            className={classname(
              styles.Label,
              variant === BigAssValueVariant.Secondary ? styles.Secondary : ""
            )}
          >
            {sub}
          </Text>
        )}
      </Space>
    </Spin>
  );
};

export default BigAssValue;
